import { displayPolygon } from "./displayPolygon";
import { hidePolygon } from "./hidePolygon";

export const displayHideAreaPolygon = (
  btn,
  areaPath,
  PathCoord,
  zoneDisplayed,
  setZoneDisplayed,
  color,
  index,
  mapData,
  mapsData,
  addListenersOnEditSiteAreaChangesPolygon,
  addListenersOnEditSiteAreaFinalPolygon,
  addListenersOnEditAreaFinalPolygon,
  polygonClick,
  polyMouseOver,
  polyMouseOut,
  showAreas
) => {

  if (areaPath === undefined) return;

  //ALWAYS clear existing first
  hidePolygon(zoneDisplayed, setZoneDisplayed);

  if (showAreas && btn) {
    displayPolygon(
      areaPath,
      PathCoord,
      setZoneDisplayed,
      color,
      index,
      mapData,
      mapsData,
      addListenersOnEditSiteAreaChangesPolygon,
      addListenersOnEditSiteAreaFinalPolygon,
      addListenersOnEditAreaFinalPolygon,
      polygonClick,
      polyMouseOver,
      polyMouseOut,
    );
  }
};